import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-tmams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-tmams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewLocationTmConstants } from "./view-application-location-tmams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import Polygon from "@arcgis/core/geometry/Polygon";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationLocationTmamsComponent = class ViewApplicationLocationTmamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewLocationTmConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewLocationTmConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewLocationTmConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewLocationTmConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewLocationTmConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewLocationTmConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewLocationTmConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewLocationTmConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewLocationTmConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewLocationTmConstants.SG_CODE_CONTROL;
    addressControl = ViewLocationTmConstants.ADDRESS_CONTROL;
    ownerControl = ViewLocationTmConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewLocationTmConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewLocationTmConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewLocationTmConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewLocationTmConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewLocationTmConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewLocationTmConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = ViewLocationTmConstants.OWNER_LABEL;
    removePropertyLabel = ViewLocationTmConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableEditing = true;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    mapComponent;
    _isMapLoaded = false;
    selectedApplicationTMAMSSubscription;
    get isMapLoaded() {
        return this._isMapLoaded;
    }
    set isMapLoaded(value) {
        this._isMapLoaded = value;
    }
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    tmApplication;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    handleRouteChange() {
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    checkSave() {
        this.selectedApplicationTMAMSSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            ;
            this.tmApplication = app;
            if (this.tmApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber, [Validators.required]),
            subdivision: new FormControl(prop.subdivision, [Validators.required]),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber, [Validators.required]),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.tmApplication.properties && this.tmApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        return propertyFoemGroup;
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.tmApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewLocationTmConstants.PROPERTY_LAYER_NAME, true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationTmamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-tmams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationTmamsComponent);
export { ViewApplicationLocationTmamsComponent };
